import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { getFullName } from '@frontend/name';
import { theme } from '@frontend/theme';
import { useModalControl } from '@frontend/design-system';
import { useCheckPaymentsEnabled } from '../../../../../../hooks/use-check-payments-enabled';
import { useScheduleRequestNotificationsAsRead } from '../hooks/use-schedule-request-notifications-as-read';
import { ScheduleRequestListItemHeader } from './ScheduleRequestListItemHeader';

export type ScheduleRequestItemHeaderProps = {
  listItem: ScheduleRequest;
  setSelectedScheduleRequest: React.Dispatch<React.SetStateAction<ScheduleRequest | null>>;
  scheduleRequestModalProps: ReturnType<typeof useModalControl>;
  locationChip?: (locationName: string) => React.ReactNode;
};

export const ScheduleRequestItemHeader = ({
  listItem,
  setSelectedScheduleRequest,
  scheduleRequestModalProps,
  locationChip,
}: ScheduleRequestItemHeaderProps) => {
  const { isPaymentsEnabled } = useCheckPaymentsEnabled(listItem.locationId);
  const { markNotificationsAsRead } = useScheduleRequestNotificationsAsRead();

  return (
    <ScheduleRequestListItemHeader
      requestVersion={listItem.linkHash || ''}
      name={getFullName(listItem.schedulee ?? {})}
      personId={listItem.schedulee?.weavePersonId}
      appointmentTime={listItem?.dateTime ?? ''}
      personPhone={listItem?.schedulee?.phoneNumber ?? ''}
      paidAmount={isPaymentsEnabled && listItem?.bookingAmount ? listItem?.bookingAmount : 0}
      locationId={listItem.locationId ?? ''}
      updateSelectedScheduleRequest={() => {
        setSelectedScheduleRequest(listItem);
        scheduleRequestModalProps.openModal();
      }}
      scheduleRequestId={listItem.id ?? ''}
      css={{ borderBottom: `1px solid ${theme.colors.neutral40}` }}
      markNotificationsAsRead={markNotificationsAsRead}
      locationChip={locationChip}
    />
  );
};
